
// import React from "react";
// import Footer from "./Footer";
// import NavBar from "./NavBar";

// const Partnership = () => {
//   return (
//     <div style={{ fontFamily: "Arial, sans-serif", backgroundColor: "#f5f5f5", margin: 0, padding: 0 }}>
//        <NavBar/>
//       {/* Header */}
//       <div
//         style={{
//           backgroundColor: "#00b050",
//           color: "white",
//           padding: "30px",
//           fontSize: "28px",
//           fontWeight: "bold",
//           textAlign: "center",
//           marginTop:'65px'
//         }}
//       >
//         Partnership 
//       </div>
//       <p style={{ width: "1200px", margin: "20px auto", padding: "20px" }}>A partnership is a very common form of business organisation. Especially in India, partnership firms are generally finding favour when the business is medium scale. So it is important that we learn about the Partnership deed and the registration of such deeds.</p>

//       {/* Content */}
//       <div style={{ width: "1200px", marginLeft: '12px', marginTop: "15px", padding: "20px" }}>
//   <div
//     style={{
//       background: "white",
//       padding: "25px",
//       borderRadius: "8px",
//       boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//       fontFamily: "Arial, sans-serif",
//       lineHeight: "1.6",
//       color: "#333"
//     }}
//   >

//     {/* About Partnership */}
//     <div>
//       <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//         About Partnership
//       </h2>
//       <div
//         style={{
//           width: "80px",
//           height: "3px",
//           background: "#22c55e",
//           borderRadius: "2px"
//         }}
//       ></div>
//     </div>

//     <p>
//       A partnership is a form of business organization where two or more individuals come together 
//       to manage and operate a business as per the terms laid down in a written agreement called 
//       the <strong>Partnership Deed</strong>. Each partner contributes resources such as capital, 
//       skills, or labor and shares in the profits and losses of the firm.
//     </p>

//     {/* Features */}
//     <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//       Key Features
//     </h2>
//     <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//     <ul>
//       <li>Formed by an agreement between two or more persons.</li>
//       <li>Minimum 2 partners required, maximum 50 (as per Indian law).</li>
//       <li>Partners share profits and losses in an agreed ratio.</li>
//       <li>Business is carried on by all partners or any one acting for all.</li>
//       <li>No separate legal identity, unlike a company.</li>
//     </ul>

//     {/* Advantages */}
//     <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//       Advantages
//     </h2>
//     <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//     <ul>
//       <li>Simple and inexpensive to start.</li>
//       <li>Pooling of resources and expertise from multiple partners.</li>
//       <li>Better decision-making with collective input.</li>
//       <li>Flexibility in management and operations.</li>
//       <li>Workload and responsibilities are shared.</li>
//     </ul>

//     {/* Disadvantages */}
//     <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//       Disadvantages
//     </h2>
//     <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//     <ul>
//       <li>Unlimited liability of partners – personal assets may be used to pay debts.</li>
//       <li>Disagreements between partners can affect business stability.</li>
//       <li>Limited access to large amounts of capital compared to companies.</li>
//       <li>Partnership dissolves automatically on the death or withdrawal of a partner (unless agreed otherwise).</li>
//     </ul>

//     {/* Types */}
//     <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//       Types of Partnership
//     </h2>
//     <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//     <ul>
//       <li><strong>General Partnership:</strong> All partners share equal rights and liabilities.</li>
//       <li><strong>Limited Partnership:</strong> Some partners have limited liability and restricted control.</li>
//       <li><strong>Partnership at Will:</strong> Exists as long as partners agree, can be dissolved anytime.</li>
//       <li><strong>Particular Partnership:</strong> Formed for a specific project or duration.</li>
//     </ul>

//     {/* Registration */}
//     <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//       Registration Process
//     </h2>
//     <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//     <p>
//       Though registration of a partnership firm is not mandatory under the Indian Partnership Act, 
//       1932, it is highly recommended. To register:
//     </p>
//     <ol>
//       <li>Create a Partnership Deed mentioning rights, duties, and profit-sharing ratio.</li>
//       <li>Fill the application form and submit with prescribed fees to the Registrar of Firms.</li>
//       <li>Attach documents like address proof, ID proof of partners, and PAN card of the firm.</li>
//       <li>On approval, the Registrar issues a Certificate of Registration.</li>
//     </ol>

//     {/* Conclusion */}
//     <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//       Conclusion
//     </h2>
//     <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//     <p>
//       A partnership is an ideal business structure for small and medium enterprises 
//       that require shared ownership, pooled resources, and joint decision-making. 
//       However, partners must carefully draft a deed and register their firm to avoid 
//       legal disputes and ensure smooth operations.
//     </p>

//   </div>
// </div>

// <Footer/>

      


       
//     </div>
//   );
// };

// export default Partnership;















import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";

const Partnership = () => {
  return (
    <div
      className="partnership"
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        className="page-header"
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: "30px",
          fontSize: "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Partnership
      </div>

      {/* Intro Paragraph */}
      <p
        className="intro"
        style={{
          maxWidth: "1200px",
          width: "95%",
          margin: "20px auto",
          padding: "20px",
        }}
      >
        A partnership is a very common form of business organisation. Especially
        in India, partnership firms are generally finding favour when the
        business is medium scale. So it is important that we learn about the
        Partnership deed and the registration of such deeds.
      </p>

      {/* Content Wrapper */}
      <div
        className="content-wrap"
        style={{
          maxWidth: "1200px",
          width: "95%",
          margin: "15px auto",
          padding: "20px",
        }}
      >
        <div
          className="card"
          style={{
            background: "white",
            padding: "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* About Partnership */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: "6px",
                fontFamily: "Times New Roman, Georgia, serif",
              }}
            >
              About Partnership
            </h2>
            <div
              className="underline"
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p>
            A partnership is a form of business organization where two or more
            individuals come together to manage and operate a business as per
            the terms laid down in a written agreement called the{" "}
            <strong>Partnership Deed</strong>. Each partner contributes
            resources such as capital, skills, or labor and shares in the
            profits and losses of the firm.
          </p>

          {/* Features */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Key Features
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul>
            <li>Formed by an agreement between two or more persons.</li>
            <li>Minimum 2 partners required, maximum 50 (as per Indian law).</li>
            <li>Partners share profits and losses in an agreed ratio.</li>
            <li>
              Business is carried on by all partners or any one acting for all.
            </li>
            <li>No separate legal identity, unlike a company.</li>
          </ul>

          {/* Advantages */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Advantages
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul>
            <li>Simple and inexpensive to start.</li>
            <li>Pooling of resources and expertise from multiple partners.</li>
            <li>Better decision-making with collective input.</li>
            <li>Flexibility in management and operations.</li>
            <li>Workload and responsibilities are shared.</li>
          </ul>

          {/* Disadvantages */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Disadvantages
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul>
            <li>
              Unlimited liability of partners – personal assets may be used to
              pay debts.
            </li>
            <li>
              Disagreements between partners can affect business stability.
            </li>
            <li>
              Limited access to large amounts of capital compared to companies.
            </li>
            <li>
              Partnership dissolves automatically on the death or withdrawal of
              a partner (unless agreed otherwise).
            </li>
          </ul>

          {/* Types */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Types of Partnership
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul>
            <li>
              <strong>General Partnership:</strong> All partners share equal
              rights and liabilities.
            </li>
            <li>
              <strong>Limited Partnership:</strong> Some partners have limited
              liability and restricted control.
            </li>
            <li>
              <strong>Partnership at Will:</strong> Exists as long as partners
              agree, can be dissolved anytime.
            </li>
            <li>
              <strong>Particular Partnership:</strong> Formed for a specific
              project or duration.
            </li>
          </ul>

          {/* Registration */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Registration Process
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p>
            Though registration of a partnership firm is not mandatory under the
            Indian Partnership Act, 1932, it is highly recommended. To register:
          </p>
          <ol>
            <li>
              Create a Partnership Deed mentioning rights, duties, and
              profit-sharing ratio.
            </li>
            <li>
              Fill the application form and submit with prescribed fees to the
              Registrar of Firms.
            </li>
            <li>
              Attach documents like address proof, ID proof of partners, and PAN
              card of the firm.
            </li>
            <li>
              On approval, the Registrar issues a Certificate of Registration.
            </li>
          </ol>

          {/* Conclusion */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Conclusion
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p>
            A partnership is an ideal business structure for small and medium
            enterprises that require shared ownership, pooled resources, and
            joint decision-making. However, partners must carefully draft a deed
            and register their firm to avoid legal disputes and ensure smooth
            operations.
          </p>
        </div>
      </div>

      <Footer />

      {/* Mobile-only fixes (desktop untouched) */}
      <style>
        {`
          .partnership { overflow-x: hidden; }
          .partnership * { box-sizing: border-box; word-break: break-word; }

          @media (max-width: 768px) {
            .page-header {
              font-size: 22px !important;
              padding: 18px !important;
            }
            .intro {
              max-width: 100% !important;
              width: 100% !important;
              margin: 12px auto !important;
              padding: 16px !important;
            }
            .content-wrap {
              max-width: 100% !important;
              width: 100% !important;
              margin: 12px auto !important;
              padding: 12px !important;
            }
            .card {
              padding: 16px !important;
              border-radius: 8px !important;
              box-shadow: 0 4px 8px rgba(0,0,0,0.08) !important;
            }
            .card h2 {
              font-size: 20px !important;
              margin-top: 16px !important;
            }
            .underline {
              width: 60px !important;
              height: 3px !important;
            }
            .card p, .card li {
              font-size: 14px !important;
              line-height: 1.6 !important;
            }
            .card ul, .card ol {
              padding-left: 18px !important;
              margin-left: 0 !important;
            }
          }

          @media (max-width: 480px) {
            .page-header {
              font-size: 20px !important;
              padding: 16px !important;
            }
            .card h2 {
              font-size: 18px !important;
            }
            .card p, .card li {
              font-size: 13px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Partnership;
